module.exports = __webpack_public_path__ + "img/desktop-neck-10_28x164.8fef6ebe.png";